import React from 'react';
import { Typography } from '@material-ui/core';
import CustomToolbar from '../../common/CustomToolbar/CustomToolbar';

export const tableSettings = options => {
  const locale = options.eventHandlers.locale;
  const eventHandlers = options.eventHandlers;

  return {
    name: <Typography variant="h3">{locale.getMsg(`tableNameHeader${options.visitType}`)}</Typography>,
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'name',
        label: locale.getMsg('name'),
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: 15,
      print: true,
      search: true,
      filter: false,
      serverSide: false,
      customToolbar: () => (
        <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
      ),
      onRowClick: rowData => {
        eventHandlers.handleSidePanel(true, rowData);
      },
    },
  };
};
